import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../core/services/alert/alert.service';
import { DocumentsService } from '../../../core/services/documents/documents.service';
import { DocumentsTypeService } from '../../../core/services/documentType/documents-type.service';
import { LocalStorageService } from '../../../core/services/localStorage/local-storage.service';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';
import { Subject } from 'rxjs';

interface FileItem {
  file: File;
  selectOption: string;
  key: string;
}
interface FormConfig {
  reference: any;
  documents: any;
  private_documents: any;
  label: string;
  type: any;
  ruleId: any;
  documentFunction?: any;
  allDocumentFunction?: any;
}
@Component({
  selector: 'app-form-documents',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './form-documents.component.html',
  styleUrl: './form-documents.component.css',
})
export class FormDocumentsComponent implements OnChanges {
  @Output() backButtonClickDocument = new EventEmitter<boolean>();
  @Output() addDocuments = new EventEmitter<boolean>();
  @Output() formSubmit = new EventEmitter<any>();
  @Output() formSubmitStage = new EventEmitter<any>();
  @Output() filesArrayChanged: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() goDocs = new EventEmitter<any>();

  @Input() clientData?: any;
  @Input() orderData?: any;
  @Input() guaranteeData?: any;
  @Input() invoiceData?: any;

  @Input() activeForm?: any;
  @Input() selectTypes?: any;
  @Input() ladata: any = {};
  @Input() rules: any = {};

  @Input() btn_submit?: any;

  existingDocuments: any[] = [];
  showExistingDocuments = false;

  orderDocumentType: string = 'type';

  isDisabled: boolean = true;
  label: string = 'client';
  varSelectType = 'orders';
  uploadFile = true;

  formConfigs: { [key: string]: FormConfig } = {};

  activeDocumentTab: number = 0; // Índice del tab activo
  showDocument: string = 'public'; // Tipo de documento a mostrar
  tabs: { title: string; key: string }[] = []; // Definición de los tabs

  private destroy$ = new Subject<void>();
  private configInitialized = false;

  constructor(
    private alertService: AlertService,
    private documentService: DocumentsService,
    private documentTypeService: DocumentsTypeService,
    private localStorageService: LocalStorageService,
    private authStateService: AuthStateService,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['activeForm'] ||
      changes['rules'] ||
      changes['orderData'] ||
      changes['clientData'] ||
      changes['guaranteeData'] ||
      changes['invoiceData']
    ) {
      this.rules = this.orderData?.rules;
      this.resetFormState();
      this.buildFormConfigs();
      this.configureTabsAndDocuments();
    }

    if (changes['readOnlyMode'] && this.readOnlyMode) {
      this.applyReadOnlyMode();
    }
  }

  private buildFormConfigs(): void {
    this.formConfigs = {
      client: {
        reference: this.clientData?.reference,
        documents: this.clientData?.documents || [],
        private_documents: this.clientData?.private_documents || [],
        label: 'client',
        type: this.clientData?.type,
        ruleId: this.rules?.client_id,
        documentFunction: this.documentService.getClientDocuments.bind(
          this.documentService,
        ),
      },
      assignee: {
        reference: this.clientData?.reference,
        documents: this.clientData?.documents || [],
        private_documents: this.clientData?.private_documents || [],
        label: 'assignee',
        type: this.clientData?.type,
        ruleId: this.rules?.client_id,
        documentFunction: this.documentService.getClientDocuments.bind(
          this.documentService,
        ),
      },
      guarantee: {
        reference: this.guaranteeData?.reference,
        documents: this.guaranteeData?.documents || [],
        private_documents: this.guaranteeData?.private_documents || [],
        label: 'guarantee',
        type: this.guaranteeData?.type,
        ruleId: this.rules?.guarantee_id,
        documentFunction: this.documentService.getClientDocuments.bind(
          this.documentService,
        ),
      },
      invoice: {
        reference: this.invoiceData?.reference,
        documents: this.invoiceData?.documents || [],
        private_documents: this.invoiceData?.private_documents || [],
        label: 'invoice',
        type: 'invoice',
        ruleId: null,
        documentFunction: this.documentService.getinvoiceDocuments.bind(
          this.documentService,
        ),
      },
      'doc-order': {
        reference: this.orderData?.reference,
        documents: this.orderData?.documents || [],
        private_documents: this.orderData?.private_documents || [],
        label: 'order',
        type: 'order',
        ruleId: this.rules?.documents,
        documentFunction: this.documentService.getOrderDocuments.bind(
          this.documentService,
        ),
        allDocumentFunction: this.documentService.downloadAllDocuments.bind(
          this.documentService,
        ),
      },
    };
  }

  private resetFormState(): void {
    this.showExistingDocuments = false;
    this.existingDocuments = [];
    this.isDisabled = true;
  }

  private updateFormState(config: FormConfig | undefined): void {
    if (config && config.reference) {
      if (this.showDocument === 'public') {
        this.existingDocuments = config.documents || [];
      } else {
        this.existingDocuments = config.private_documents || [];
      }

      this.isDisabled = false;
      this.label = config.label;
      this.varSelectType = config.type;
      this.uploadFile = true;

      if (config.ruleId === 'r') {
        this.uploadFile = false;
      }

      this.showExistingDocuments = this.existingDocuments.length > 0;
    }
  }

  isWorkshopUser: boolean = false;

  setActiveTab(index: number) {
    if (this.isWorkshopUser) {
      console.log('Workshop user cannot change tabs');
      return;
    }

    this.activeDocumentTab = index;
    this.showDocument = this.tabs[index].key;

    const config = this.formConfigs[this.activeForm];
    if (config) {
      if (this.showDocument === 'public') {
        this.existingDocuments = config.documents || [];
      } else {
        this.existingDocuments = config.private_documents || [];
      }
      this.showExistingDocuments = this.existingDocuments.length > 0;
    }
  }

  getDocuments() {
    const config = this.formConfigs[this.activeForm];
    if (config && config.reference && config.documentFunction) {
      this.alertService.loading('swal_messages.search_documents');
      config.documentFunction(config.reference).subscribe({
        next: (data: any) => {
          this.updateFormConfigsWithFreshData(data.data);
          if (this.showDocument === 'public') {
            this.existingDocuments = data.data.documents || [];
          } else {
            this.existingDocuments = data.data.private_documents || [];
          }

          this.showExistingDocuments = this.existingDocuments.length > 0;
          this.alertService.close();
        },
        error: (error: any) => {
          this.existingDocuments = [];
          this.alertService.close();
        },
      });
    } else {
      this.alertService.close();
    }
  }

  private updateFormConfigsWithFreshData(data: any): void {
    if (this.formConfigs[this.activeForm]) {
      this.formConfigs[this.activeForm].documents = data.documents || [];
      this.formConfigs[this.activeForm].private_documents =
        data.private_documents || [];
    }

    this.updateParentData(data);
  }

  private updateParentData(data: any): void {
    switch (this.activeForm) {
      case 'doc-order':
        if (this.orderData) {
          this.orderData.documents = data.documents || [];
          this.orderData.private_documents = data.private_documents || [];
        }
        break;
      case 'client':
        if (this.clientData) {
          this.clientData.documents = data.documents || [];
          this.clientData.private_documents = data.private_documents || [];
        }
        break;
      case 'guarantee':
        if (this.guaranteeData) {
          this.guaranteeData.documents = data.documents || [];
          this.guaranteeData.private_documents = data.private_documents || [];
        }
        break;
      case 'invoice':
        if (this.invoiceData) {
          this.invoiceData.documents = data.documents || [];
          this.invoiceData.private_documents = data.private_documents || [];
        }
        break;
    }
  }
  emitBackButtonClick() {
    this.files = [];
    this.existingDocuments = [];
    this.filesArrayChanged.emit(this.files);
    this.backButtonClickDocument.emit(true);
  }

  emitAddDocuments() {
    this.addDocuments.emit(true);
  }

  onSubmit() {
    const isValid = this.checkSelectOptionDiversity(this.files);

    if (!isValid) {
      this.alertService.error('swal_messages.document_type_excess');
    } else {
      this.alertService.loading(
        'Por favor espera mientras se añaden los documentos.',
      );

      const formData = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        formData.append(`file[${i}]`, this.files[i].file);
        formData.append(`type[${i}]`, this.files[i].selectOption);
      }
      formData.append('visibility', this.showDocument);
      switch (this.activeForm) {
        case 'guarantee':
          formData.append('client_id', this.guaranteeData.reference);
          break;
        case 'assignee':
        case 'client':
          formData.append('client_id', this.clientData.reference);
          break;
        case 'invoice':
          formData.append('invoice_id', this.invoiceData.reference);
          break;
        case 'doc-order':
          formData.append('order_id', this.orderData.reference);
          break;
      }

      this.documentService.addDocument(formData).subscribe({
        next: (data) => {
          if (data.data.next_stage != null) {
            this.files = [];
            const stageTranslation = this.translateService.instant(
              `badge-status_select-stage.${data.data.next_stage}`,
            );
            const messageWithParams = this.translateService.instant(
              'swal_messages.change_stage_message',
              { stage: stageTranslation },
            );
            const title = this.translateService.instant(
              'swal_messages.change_stage',
            );
            const confirmButtonText = this.translateService.instant(
              'swal_messages.confirm',
            );
            const cancelButtonText = this.translateService.instant(
              'swal_messages.notes.cancel',
            );

            this.alertService
              .confirmation2(
                messageWithParams,
                title,
                confirmButtonText,
                cancelButtonText,
              )
              .then((result) => {
                if (result.isConfirmed) {
                  this.alertService.loading('swal_messages.please_wait');
                  this.formSubmitStage.emit(data.data.next_stage);
                  this.alertService.close();
                }
              });
          } else {
            this.alertService
              .successOk('swal_messages.add_document_success')
              .then((result) => {
                if (result.isConfirmed) {
                  this.files = [];
                  this.filesArrayChanged.emit(this.files);
                  this.getDocuments();
                }
              });
          }
        },
        error: (error) => {
          this.alertService.error(error.error).then((result) => {
            if (result.isConfirmed) {
            }
          });
        },
      });
    }
  }

  downloadAllDocuments() {
    this.alertService.loading('swal_messages.please_wait_documents');
    const config = this.formConfigs[this.activeForm];
    if (config && config.reference && config.documentFunction) {
      config.allDocumentFunction(config.reference).subscribe({
        next: (data: any) => {
          let url = data.data.zip_url;
          const a = document.createElement('a');
          a.href = url;
          a.click();
          this.alertService.close();
        },
        error: (error: any) => {
          this.alertService.close();
        },
      });
    } else {
      this.alertService.close();
    }
  }

  checkSelectOptionDiversity(
    data: Array<{ file: any; selectOption: string; key: string }>,
  ): boolean {
    if (data.length <= 3) {
      return true; // Si hay 3 o menos elementos, no hay restricciones.
    }
    // Contar las ocurrencias de cada `selectOption`.
    const optionCounts: Record<string, number> = {};
    data.forEach((item) => {
      const option = item.selectOption;
      optionCounts[option] = (optionCounts[option] || 0) + 1;
    });

    // Verificar si algún `selectOption` excede el 70 %.
    const total = data.length;
    for (const option in optionCounts) {
      if (optionCounts['other'] && optionCounts['other'] / total >= 0.7) {
        return false;
      }
    }
    return true; // Si no hay ningún `selectOption` con el 70 % o más, cumple.
  }

  changeForm(form: string) {
    this.activeForm = form;
    this.getDocuments();
  }

  orderDocs(type: string) {
    this.orderDocumentType = type;
    this.sortDocumentsByDate(this.orderDocumentType);
  }

  sortDocumentsByDate(type: string) {
    if (type == 'type') {
      this.existingDocuments = this.existingDocuments.sort((a, b) => {
        return a.type.localeCompare(b.type);
      });
    }
    if (type == 'date_asc') {
      this.existingDocuments = this.existingDocuments.sort((a, b) => {
        return (
          new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
        );
      });
    }
    if (type == 'date_desc') {
      this.existingDocuments = this.existingDocuments.sort((a, b) => {
        return (
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );
      });
    }
  }

  //--------------------------------------------------------------------
  //------------------IMGDRAG AND DROP STUFF----------------------------
  //--------------------------------------------------------------------

  @Output() filesDropped = new EventEmitter<FileList>();
  files: FileItem[] = [];

  actualizarArchivos(nuevosArchivos: any[]) {
    this.files = nuevosArchivos;
    this.filesArrayChanged.emit(this.files);
  }

  private toggleHighlight(event: DragEvent, isOver: boolean) {
    const target = event.target as HTMLElement;
    if (target) {
      target.classList.toggle('over', isOver);
    }
  }

  isImage(file: File): boolean {
    return file.type.startsWith('image/');
  }

  getThumbnailSrc2(name: string): string {
    const patterns = {
      jpg: /\.(jpg|jpeg|png)$/i,
      pdf: /\.pdf$/i,
      doc: /\.(docx?|dotx?)$/i,
      xls: /\.(xls?|xlsx?)$/i,
      zip: /\.zip$/i,
    };

    for (const [key, pattern] of Object.entries(patterns)) {
      if (pattern.test(name)) {
        return `../../../assets/icons/${key}.svg`;
      }
    }

    return '../../../assets/icons/file.svg';
  }

  getThumbnailSrc3(file: File): string {
    const patterns = {
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      pdf: 'application/pdf',
      doc: 'application/msword',
      csv: 'text/csv',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      xslx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'word-openxml':
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      xls: 'application/vnd.ms-excel',
      'xls-openxml':
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    };

    for (const [key, mimeType] of Object.entries(patterns)) {
      if (file.type === mimeType) {
        switch (key) {
          case 'jpg':
          case 'jpeg':
          case 'png':
            return `../../../assets/icons/jpg.svg`;
            break;
          case 'pdf':
            return `../../../assets/icons/pdf.svg`;
            break;
          case 'word-openxml':
          case 'doc':
          case 'docx':
            return `../../../assets/icons/doc.svg`;
            break;
          case 'xls-openxml':
          case 'xls':
            return `../../../assets/icons/xls.svg`;
            break;
          default:
            return '../../../assets/icons/file.svg';
            break;
        }
      }
    }
    return '../../../assets/icons/file.svg';
  }

  getThumbnailSrc(file: File): string {
    const mimeToIcon: Record<string, string> = {
      'image/jpeg': '../../../assets/icons/jpg.svg',
      'image/png': '../../../assets/icons/jpg.svg',
      'application/pdf': '../../../assets/icons/pdf.svg',
      'application/msword': '../../../assets/icons/doc.svg',
      'text/csv': '../../../assets/icons/file.svg',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        '../../../assets/icons/doc.svg',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        '../../../assets/icons/xls.svg',
      'application/vnd.ms-excel': '../../../assets/icons/xls.svg',
    };

    return mimeToIcon[file.type] || '../../../assets/icons/file.svg';
  }

  onFileInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const newFiles = input.files;
    if (newFiles && newFiles.length > 0) {
      for (const file of Array.from(newFiles)) {
        if (
          !this.files.some(
            (f) => f.file.name === file.name && f.file.size === file.size,
          )
        ) {
          var selectOption = 'defaultOption';
          this.alertService.loading('swal_messages.please_wait');
          var opt = this.activeForm == 'doc-order' ? 'orders' : 'clients';
          this.documentTypeService.decodeType(opt, file.name).subscribe({
            next: (data) => {
              this.alertService.close();
              selectOption = data.data;
              const newFileItem: FileItem = {
                file: file,
                selectOption: selectOption,
                key: selectOption,
              };
              this.files.push(newFileItem);
              this.filesArrayChanged.emit(this.files);
            },
            error: (error) => {
              this.alertService.close();
              const newFileItem: FileItem = {
                file: file,
                selectOption: selectOption,
                key: selectOption,
              };
              this.files.push(newFileItem);
              this.filesArrayChanged.emit(this.files);
            },
          });
        }
      }
      this.filesDropped.emit(newFiles);
    }
  }

  selectOptionChanged(event: Event, index: number) {
    const selectElement = event.target as HTMLSelectElement;
    const option = selectElement.value;
    this.files[index].selectOption = option;
  }

  pickAColor(type: string): string {
    const colorMap: Record<string, string> = {
      identification: '#f0ab96',
      organization_identification: '#f0ab96',
      offer: '#f0ab96',

      payroll: '#f0d3b1',
      company_deed: '#f0d3b1',
      offer_signed: '#f0d3b1',

      employment_record: '#a7cce0',
      ownership: '#a7cce0',
      contract_signed: '#a7cce0',

      bank_account_ownership: '#9daff0',
      balance: '#9daff0',
      guarantee_contract: '#9daff0',

      receipt: '#c19fc2',
      p_and_l: '#c19fc2',
      guarantee_contract_signed: '#c19fc2',

      pension_revaluation: '#f5f3a8',
      '200_organization_income_tax_return': '#f5f3a8',
      delivery_certificate: '#f5f3a8',

      '037_census_declaration': '#ded9d5',
      '303_vat_return': '#ded9d5',
      contract: '#ded9d5',

      '100_income_tax_return': '#8db99e',
      '390_vat_summary': '#8db99e',

      '130_quaterly_income_tax_return': '#4fc3c2',
      '131_quaterly_income_tax_return': '#a2d4df',

      aux1: '#eaa3b5',
      aux2: '#c2dbbe',
      axu3: '#f9f6c1',
      aux4: '#f7bd98',
    };

    return colorMap[type] || '#d0e5e8';
  }

  getDownloadName(documentName: string): string {
    // Aquí puedes personalizar el nombre de descarga como desees
    const timestamp = new Date().getTime();
    return `${documentName}_${timestamp}.pdf`; // Cambia la extensión según el tipo de archivo
  }

  emitgoDocs() {
    this.goDocs.emit(true);
  }

  /************************ */

  private configureTabsAndDocuments(): void {
    const config = this.formConfigs[this.activeForm];

    if (!config) {
      this.isDisabled = true;
      return;
    }

    if (this.readOnlyMode) {
      this.tabs = [{ title: 'public', key: 'public' }];
      this.showDocument = 'public';
      this.activeDocumentTab = 0;
      this.existingDocuments = config.documents || [];
    } else {
      this.tabs = [
        { title: 'public', key: 'public' },
        { title: 'private', key: 'private' },
      ];
      this.existingDocuments = config.documents || [];
    }

    this.isDisabled = !config.reference;
    this.label = config.label;
    this.varSelectType = config.type;

    if (this.readOnlyMode) {
      this.uploadFile = false;
    } else {
      this.uploadFile = config.ruleId !== 'r';
    }

    this.showExistingDocuments = this.existingDocuments.length > 0;
  }

  /**************** */

  @Input() readOnlyMode: boolean = false;
  @Input() hideUpload: boolean = false;
  @Input() hideDelete: boolean = false;

  /*    get isDisabled(): boolean {
    return this.readOnlyMode ? true : this._isDisabled;
  }

  get uploadFile(): boolean {
    return this.readOnlyMode ? false : this._uploadFile;
  } */

  // Variables privadas para la lógica interna
  private _isDisabled: boolean = true;
  private _uploadFile: boolean = true;
  private _label: string = 'client';
  private _varSelectType = 'orders';

  private applyReadOnlyMode() {
    // Deshabilitar funcionalidades en modo lectura
    this._uploadFile = false;
    this.btn_submit = false;
  }
}
